/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `active` - Active
 * * `inactive` - Inactive
 * * `pending` - Pending
 * @export
 */
export const SubscriptionStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
    Pending: 'pending'
} as const;
export type SubscriptionStatusEnum = typeof SubscriptionStatusEnum[keyof typeof SubscriptionStatusEnum];


export function instanceOfSubscriptionStatusEnum(value: any): boolean {
    for (const key in SubscriptionStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(SubscriptionStatusEnum, key)) {
            if (SubscriptionStatusEnum[key as keyof typeof SubscriptionStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubscriptionStatusEnumFromJSON(json: any): SubscriptionStatusEnum {
    return SubscriptionStatusEnumFromJSONTyped(json, false);
}

export function SubscriptionStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionStatusEnum {
    return json as SubscriptionStatusEnum;
}

export function SubscriptionStatusEnumToJSON(value?: SubscriptionStatusEnum | null): any {
    return value as any;
}

export function SubscriptionStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): SubscriptionStatusEnum {
    return value as SubscriptionStatusEnum;
}

